import { TRPCClientError } from "@trpc/client"
import type { AppRouter } from "../server/routers/_app"

// Helper to check if error is a tRPC error with specific code
export function isTRPCClientError(
  error: unknown
): error is TRPCClientError<AppRouter> {
  return error instanceof TRPCClientError
}

/** Field errors thrown on the server are wrapped as TRPCClientError with data.code FIELD_ERROR */
export function getTrpcFieldError(
  error: unknown
): { fields: string[]; message: string } | null {
  if (!isTRPCClientError(error)) return null
  if (error.data?.code !== "FIELD_ERROR") return null
  const data = error.data as { fields?: unknown }
  const raw = data.fields
  const fields = Array.isArray(raw)
    ? raw.filter((f): f is string => typeof f === "string")
    : []
  return { fields, message: error.message }
}

export function isUnauthorizedError(error: unknown): boolean {
  if (isTRPCClientError(error)) {
    return error.data?.code === "UNAUTHORIZED"
  }
  // Support legacy Blitz errors during migration
  return (
    error instanceof Error &&
    (error.name === "AuthenticationError" || error.name === "UNAUTHORIZED")
  )
}

export function isForbiddenError(error: unknown): boolean {
  if (isTRPCClientError(error)) {
    return error.data?.code === "FORBIDDEN"
  }
  // Support legacy Blitz errors during migration
  return (
    error instanceof Error &&
    (error.name === "AuthorizationError" || error.name === "FORBIDDEN")
  )
}

// Re-export custom errors from auth/errors for compatibility
export {
  NoOrganizationSelectedError,
  NoGroupSelectedError,
  NoGroupsError,
  ShowGroupMigrationError,
  MultipleSessionsError,
  ContentNotAvailableError,
} from "../auth/errors"
